import { IconButton, Typography } from "@material-ui/core";
import AlertDialog from "pages/common/AlertDialog";
import * as React from "react";
import HelpIcon from "@material-ui/icons/Help";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import { InfoOutlined } from "@material-ui/icons";
import Icon from "../components/Icon"

const StickModeHelper = ({ stickMode }: { stickMode: boolean }) => {
  let text = "";
  const [openAlertDialog, setOpenAlertDialog] = React.useState(false);
  const [step, setStep] = React.useState(1);
  const container = React.useRef(null);

  if (stickMode) {
    text = `Mode "Coller 2 formes" activé.`;
  }

  const onChangeStep = (step: number) => {
    setStep(step);
    if (document.getElementById("help-dialog-content")) {
      document
        .getElementById("help-dialog-content")
        ?.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return text === "" ? null : (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
      ref={container}
    >
      <Typography>{text}</Typography>
      <Icon 
        component={HelpIcon}
        color="#2948FF" 
        onClick={() => setOpenAlertDialog(true)} 
      />
      <AlertDialog
        dialogContentId={"help-dialog-content"}
        open={openAlertDialog}
        onClose={() => {
          setOpenAlertDialog(false);
        }}
        title="Coller 2 formes"
        text={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {step === 1 && <StepOne setStep={onChangeStep} />}
            {step === 2 && <StepTwo setStep={onChangeStep} />}
            {step === 3 && <StepThree setStep={onChangeStep} />}
            <p
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <InfoOutlined
                style={{
                  marginRight: "5px",
                }}
              />{" "}
              Vous pouvez annuler ce mode en re-cliquant sur l'icone "Coller 2
              formes" dans la barre d'outils.
            </p>
          </div>
        }
        onAccept={() => {
          setOpenAlertDialog(false);
        }}
        acceptLabel="Compris"
      />
    </div>
  );
};

export default StickModeHelper;
